import React, { ReactNode } from 'react';

import { Container, ContainerProps, Text } from '@lglp/components';
import PrismicRichText, {
  Elements,
  RichTextBlock,
  Serializer,
} from 'prismic-richtext';

import { LinkedComponent } from '../LinkedComponent';
import { Tooltip } from '../Tooltip';

const serialize: (
  props: ContainerProps,
  prefix?: ReactNode
) => Serializer<ReactNode | ReactNode[]> =
  ({ className, key, ...rest } = {}, prefix) =>
  (type, element, content, children, index) => {
    const props = {
      key: [key, index].filter(Boolean).join('-'),
      ...rest,
    };

    switch (type) {
      // ----------------------------
      // We dont use this tag for now, so we set paragraph by default
      case Elements.heading1:
      case Elements.heading2:
      case Elements.heading3:
      case Elements.heading4:
      case Elements.heading5:
      case Elements.heading6:
      case Elements.preformatted:
      case Elements.paragraph:
        return (
          <Text
            body={[index === 0 && prefix, ...children]}
            className={className}
            {...props}
          />
        );
      case Elements.strong:
        return (
          <Container as="strong" className={type} {...props}>
            {children}
          </Container>
        );
      case Elements.em:
        return (
          <Container as="em" className={type} {...props}>
            {children}
          </Container>
        );
      case Elements.hyperlink:
        return (
          <LinkedComponent link={element.data} className={type} {...props}>
            {children}
          </LinkedComponent>
        );
      case Elements.label:
        return (
          <Container as="span" className={type} {...props}>
            {children}
          </Container>
        );
      case Elements.span:
        return content;
      case 'note':
        return (
          <Container as="span" className={type} {...props}>
            {element.text}
            <sup>({element.data[0]})</sup>
          </Container>
        );
      case 'infobulle':
        return (
          <Tooltip
            text={element.text}
            tooltipText={element.data[1]}
            tooltipTitle={element.data[0]}
          />
        );
      case Elements.listItem:
      case Elements.oListItem:
      case Elements.list:
      case Elements.oList:
      case Elements.image:
      case Elements.embed:
      default:
        return null;
    }
  };

export const asHtml = (
  richText: RichTextBlock[],
  prefix?: ReactNode,
  props?: ContainerProps
) => PrismicRichText.serialize(richText, serialize(props, prefix));
